import React, { useEffect, useState } from "react";
import "./Collections.css";
import axios from "axios";
import Slider from "react-slick";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProductCard from "../../components/ProductCard/ProductCard";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";

function AllCollections() {
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    scrollToTop();
  }, [navigate]);

  const [collectionItems, setCollectionItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, []);

  const baseURL = "https://karstar.in/";
console.log(baseURL);
  const fetchProduct = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/api/client_api/productCategories/index.php`
      );
      const fetchedItems = response.data;
      console.log(fetchedItems);
      setCollectionItems(fetchedItems);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const GenderCard = ({ item }) => (
    <Link to={`/collection/${item.name}`}>
      <Card className="me-1 bg-transparent card-hover gendersCard border-0">
        <div className="">
          <Card.Img
            src={baseURL + item.icon_image_path}
            alt="Gender Image"
            style={{ borderRadius: "10px" }}
          />
          {/* <div className="card-overlay"></div> */}
        </div>
        <Card.Title
          className="text-center my-3 fw-bold"
          style={{ fontSize: "14px" }}
        >
          {item.name}
        </Card.Title>
      </Card>
    </Link>
  );

  const Breadcrumb = ({ product }) => {
    return (
      <div className="breadcrumb-container">
        <div className="breadcrumb">
          <Link to="/products" className="breadcrumb-item text-black me-2">
            Karstar
          </Link>
          <Link to="/categories" className="breadcrumb-item text-black me-2">
            Collections
          </Link>
        </div>
        <h2 className="heading-title text-black py-2 text-capitalize fw-bold">
          All Collections
        </h2>
      </div>
    );
  };

  return (
    <div className="sectionView container mt-3">
      <Breadcrumb />
      {error && <div>{error}</div>}
      <Row className="g-2">
        {collectionItems.map((item) => (
          <Col xs={4} md={3} lg={2} key={item.id}>
            <GenderCard item={item} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default AllCollections;
